import type { PermissionCode } from '@/constants/permissions';
import { useUserStore } from '@/stores/userStore';

export type VerifyGrantWrapperProps<T extends React.ReactNode> = {
  /**
   * 权限码，传入后会判断用户是否有该权限，没有则不渲染
   */
  grant?: PermissionCode;

  /**
   * 权限校验失败时的回调
   */
  onVerifyFail?: (grant: PermissionCode) => void;

  /**
   * 子组件
   */
  children?: T;
};
export const VerifyGrantWrapper = <T extends React.ReactNode>({
  grant,
  onVerifyFail,
  children,
}: VerifyGrantWrapperProps<T>) => {
  const permissionCodes = useUserStore((state) => state.userInfo?.permissionCodes);

  if (grant && (!permissionCodes || !permissionCodes.includes(grant))) {
    onVerifyFail?.(grant);
    return null;
  }
  return children;
};
